import { setAddress } from '../Address/actions.js'
import { push } from 'connected-react-router'

export const loadCart = (client, redirect) => () => {
  return (dispatch, getState) => {
    if (redirect) {
      dispatch({ type: 'FETCH_CART_REDIRECT' })
    } else {
      dispatch({ type: 'FETCH_CART' })
    }

    const handleSuccess = payload => {
      dispatch({ type: 'FETCH_CART_SUCCESS', payload })
      const {
        address,
        participant: { address: addressParticipant }
      } = getState()
      if (address && address.zipCode) {
        dispatch(fetchShipping(address.zipCode))
      } else if (payload.data.shippingAddress) {
        dispatch(setAddress(payload.data.shippingAddress))
      } else if (addressParticipant && addressParticipant.zipCode) {
        let addressData = {
          cepError: false,
          city: addressParticipant.city && addressParticipant.city.value,
          district:
            addressParticipant.district && addressParticipant.district.value,
          hasError: false,
          isLoading: false,
          state: addressParticipant.state && addressParticipant.state.value,
          street:
            addressParticipant.addressText &&
            addressParticipant.addressText.value,
          zipCode:
            addressParticipant.zipCode && addressParticipant.zipCode.value,
          number: addressParticipant.number && addressParticipant.number.value,
          complement:
            addressParticipant.complement &&
            addressParticipant.complement.value,
          reference:
            addressParticipant.reference && addressParticipant.reference.value
        }
        dispatch(setAddress(addressData))
      }
      if (redirect) dispatch(push('/cart'))
    }

    const handleError = err => {
      dispatch({ type: 'FETCH_CART_FAIL', error: { data: err } })
    }

    client
      .get(`/v1/carts/me`)
      .then(handleSuccess)
      .catch(handleError)
  }
}

export const addItemToCartSuccess = ({ data }) => ({
  type: 'ADD_ITEM_TO_CART_SUCCESS',
  payload: { data }
})

export const addItemToCartRedirectSuccess = ({ data }) => ({
  type: 'ADD_ITEM_TO_CART_REDIRECT_SUCCESS',
  payload: { data }
})

export const addItem = client => (body, redirect) => {
  return (dispatch, getState) => {
    const {
      oidc: { user }
    } = getState()
    if (!user) {
      dispatch(push('/auth/login'))
    } else {
      if (redirect) {
        dispatch({ type: 'ADD_ITEM_TO_CART_REDIRECT' })
      } else {
        dispatch({ type: 'ADD_ITEM_TO_CART' })
      }

      const handleSuccess = response => {
        if (redirect) {
          dispatch(addItemToCartRedirectSuccess(response))
        } else {
          dispatch(addItemToCartSuccess(response))
        }

        dispatch(loadCart(client, redirect)())
      }

      const handleError = err => {
        dispatch({ type: 'ADD_ITEM_TO_CART_FAIL', error: { data: err } })
        dispatch(loadCart(client, false)())
      }

      client
        .post('/v1/carts/me/items', body)
        .then(handleSuccess)
        .catch(handleError)
    }
  }
}

export const dispatchShipping = zipCode => ({
  type: 'FETCH_CART_SHIPPING',
  payload: {
    client: 'cloudloyalty',
    request: {
      url: `/v1/carts/me/shipping/rates/${zipCode}`
    }
  }
})

export const fetchShipping = client => zipCode => {
  return dispatch => {
    dispatch(dispatchShipping(zipCode))

    client
      .get(`v1/addresses/${zipCode}`)
      .then(responseAddress => {
        getModelAddress(responseAddress, zipCode)
      })
      .catch()

    const getModelAddress = (address, zipCode) => {
      let { streetType, street, district, city, state } = address.data

      const model = {
        street: `${streetType} ${street}`,
        district: `${district}`,
        city: `${city}`,
        state: `${state}`,
        zipCode: `${zipCode}`
      }
      dispatch(setAddress(model))
    }
  }
}

export const resetShipping = () => ({
  type: 'RESET_CART_SHIPPING'
})

export const clearCartError = () => ({
  type: 'CLEAR_ERROR_CART'
})

export const removeItem = client => sku => {
  return (dispatch, getState) => {
    dispatch({ type: 'REMOVE_ITEM_FROM_CART' })

    const {
      address,
      participant: { address: participantAddress }
    } = getState()

    if (address && address.zipCode) {
      dispatch(fetchShipping(client)(address.zipCode))
    } else if (participantAddress && participantAddress.zipCode) {
      dispatch(fetchShipping(client)(participantAddress.zipCode))
    }

    const handleSuccess = response => {
      dispatch(removeItemSuccess(response))
      dispatch(loadCart(client)())
    }

    const handleError = err => dispatch(removeItemFail(err))

    client
      .delete(`/v1/carts/me/items/${sku}`)
      .then(handleSuccess)
      .catch(handleError)
  }
}

export const removeItemSuccess = () => ({
  type: 'REMOVE_ITEM_FROM_CART_SUCCESS',
  payload: null
})

export const removeItemFail = err => ({
  type: 'REMOVE_ITEM_FROM_CART_FAIL',
  error: { data: err }
})

export const updateItem = client => item => {
  return (dispatch, getState) => {
    const {
      address,
      participant: { address: participantAddress }
    } = getState()

    if (address && address.zipCode) {
      dispatch(fetchShipping(client)(address.zipCode))
    } else if (participantAddress && participantAddress.zipCode) {
      dispatch(fetchShipping(client)(participantAddress.zipCode))
    }

    dispatch({ type: 'UPDATE_ITEM_FROM_CART' })

    const handleSuccess = response => {
      dispatch(updateItemSuccess(response))
      dispatch(loadCart(client)())
    }

    const handleError = err => dispatch(updateItemFail(err))

    const { sku, vendorId, quantity, email } = item
    client
      .put(`/v1/carts/me/items/${sku}`, {
        vendorId,
        quantity,
        email
      })
      .then(handleSuccess)
      .catch(handleError)
  }
}

export const updateItemSuccess = () => ({
  type: 'UPDATE_ITEM_FROM_CART_SUCCESS',
  payload: null
})

export const updateItemFail = err => ({
  type: 'UPDATE_ITEM_FROM_CART_FAIL',
  error: { data: err }
})

export const updateShippingAddress = client => body => {
  return (dispatch, _) => {
    dispatch({ type: 'UPDATE_SHIPPING_ADDRESS_TO_CART' })

    const handleSuccess = _ => {
      dispatch({
        type: 'UPDATE_SHIPPING_ADDRESS_TO_CART_SUCCESS',
        shipping: body
      })
      dispatch(loadCart(client)())
    }

    const handleError = err =>
      dispatch({
        type: 'UPDATE_SHIPPING_ADDRESS_TO_CART_FAIL',
        error: { data: err }
      })

    client
      .put('/v1/carts/me/shipping', body)
      .then(handleSuccess)
      .catch(handleError)
  }
}

export const ChangeEmail = email => ({
  type: 'CHANGE_EMAIL',
  email,
  payload: {
    client: 'cloudloyalty',
    request: {
      method: 'post',
      url: `/v1/carts/1/me/emailAddress?email=${email}`
    }
  }
})

export const updateCoupon = code => {
  return {
    type: 'CART_UPDATE_COUPON',
    payload: {
      client: 'cloudloyalty',
      request: {
        method: 'patch',
        url: '/v1/carts/me/coupon',
        data: { code }
      }
    }
  }
}

export const removeCoupon = () => {
  return {
    type: 'CART_REMOVE_COUPON',
    payload: {
      client: 'cloudloyalty',
      request: {
        method: 'delete',
        url: '/v1/carts/me/coupon'
      }
    }
  }
}

export const clearCouponError = () => ({
  type: 'CART_COUPON_CLEAR_ERROR'
})

export default (client, redirect) => ({
  loadCart: loadCart(client),
  ChangeEmail,
  addItemToCartSuccess,
  addItem: addItem(client, redirect),
  fetchShipping: fetchShipping(client),
  removeItem: removeItem(client),
  updateItem: updateItem(client),
  resetShipping,
  updateShippingAddress: updateShippingAddress(client),
  clearCartError: clearCartError,
  updateCoupon,
  removeCoupon,
  clearCouponError,
  redirect: push('/cart'),
  dispatchShipping
})



// WEBPACK FOOTER //
// ./src/features/Cart/actions.js